import zooozLogo from "@/assets/zooozlogo.svg";
import { useGetMyTokensQuery } from "@/store/apis/vipApi";
import { useAuth } from "@base-identity/react";
import { ComponentProps,  PropsWithChildren,  } from "react";
import { cn } from "@/lib/utils";
import { TokenContext, useTokenContext } from "@/hooks/context/token-context";


const TokenView = ({children}:PropsWithChildren) => {
  const auth = useAuth();
  const { data, isLoading, isFetching } = useGetMyTokensQuery(undefined, {
    skip: !auth.isLoaded || !auth.isSignedIn,
  });

  const numOfTokens =
    data?.data.reduce((acc, item) => {
      return acc + item.tokenAvail;
    }, 0) || 0;

  return (
    <TokenContext.Provider
      value={{
        numOfTokens,
        isLoading: !auth.isLoaded || (auth.isSignedIn && (isLoading || isFetching)),
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

export default TokenView;

const TokenViewContent = ({children}:PropsWithChildren)=>{
    
    return (
      <div className="flex items-center " dir="rtl">
        {children}
      </div>
    )
}
const TokenViewFooter = ({children}:PropsWithChildren)=>{
    return (
      <div className="text-xs" dir="rtl">
        {children}
      </div>
    )
}

const TokenIcon = ({className, ...rest}:ComponentProps<'img'>)=><img src={zooozLogo} alt="Zoooz Logo" {...rest} className={cn("w-10 h-10", className)} />

const TokenNumber = ({className, ...rest}:ComponentProps<'span'>)=>{
    const { numOfTokens, isLoading } = useTokenContext();
    return(
      <>
      {isLoading ? <span className={cn("animate-pulse ease-in-out duration-700", className)} {...rest}>...</span> : <span className={className} {...rest}>{numOfTokens}</span>}
      </>
      
    )
}

export {TokenViewContent, TokenViewFooter, TokenIcon}


TokenView.Content = TokenViewContent
TokenView.Footer = TokenViewFooter
TokenView.Icon = TokenIcon
TokenView.Number = TokenNumber

  // <div dir="rtl" className="grid grid-rows-2 gap-4">
  //       <div className="flex items-center " dir="rtl">
  //           <img src={zooozLogo} alt="Zoooz Logo" className="w-10 h-10" />
  //           <Font family='openSans' weight={800}>
  //           <div className="text-lg  text-gray-700">נותרו לך {numOfTokens} מטבעות</div>
  //           </Font>
  //       </div>
  //       <span className="text-xs">
  //           <Info className="inline w-4 h-4 font-bold" /> מטבעות אלו משממשים לרכישת פרטי התקשרות עם משקיעי IMACT 
  //       </span>
  //       </div>


